'use strict';

import React, {Component} from "react";
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames'

import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import appStore from '@uw-it-sis/lib-react/lib/AppStore';
import OrgUtils from "./OrgUtils";

import {MetricLabels, MetricKeys} from './Constants';

const analyticsStore = appStore.getAnalyticsStore();


/**
 *
 * Displays related links as list in desktop and tablet views, and as dropdown on mobile
 *
 */
class RelatedLinks extends Component {
    constructor(props) {
        super(props);

        this.props = props;
    }

    render() {
        // links prop needs to have at least 1 item, if not return null
        if ( this.props.links.length === 0 ) {
            return null;
        }

        let listLinks = [];
        let dropdownLinks = [];

        this.props.links.map(function(data, index) {
            // Check items in the links prop to make sure a link label and href are passed
            if (!data.hasOwnProperty("label") || !data.hasOwnProperty("href") ) {
                return null;
            }

            // If the item does not have the router key, assume its true to make a React Router Link
            if ( !data.hasOwnProperty("router") ) {
                data.router = true;
            }

            let className = null;
            if ( data.hasOwnProperty("className") ) {
                className = data.className;
            }

            // fall back to the url if we can't map it to a page
            let dest = OrgUtils.getPageFromUrl(data.href, appStore.getApplicationName()) || data.href;

            let onClick = () => {
                const labels = analyticsStore.label(MetricLabels.navLinkDestName, dest).get();
                analyticsStore.addEvent(MetricKeys.navigation, labels, {navtype: "related"});
            }

            let listLink = data.router
                ? <Link to={data.href} className={className} onClick={onClick}> {data.label} </Link>
                : <a href={data.href}  className={className} onClick={onClick} target={data.target ? data.target : '_self'}> {data.label} </a>

            let dropdownLink = data.router
                ? <Dropdown.Item as={Link} to={data.href} eventKey={index} key={index}>{data.label}</Dropdown.Item>
                : <Dropdown.Item href={data.href} target={data.target ? data.target : '_self'} eventKey={index} key={index}>{data.label}</Dropdown.Item>


            listLinks.push(
                <li className="list-inline-item" key={index}>
                    {listLink}
                </li>
            );

            dropdownLinks.push(dropdownLink);
        });

        let mobileDropdown = null;
        if ( this.props.links.length > 1 ) {
            mobileDropdown =
                <div className={classNames("d-block", "d-md-none")}>
                    <DropdownButton id="related-links-dropdown" title="Related" variant="link" size="sm" align="end">
                        {dropdownLinks}
                    </DropdownButton>
                </div>;
        }

        return (
            <div id="related-links" className="position-absolute top-0 end-0 py-2 px-3 d-print-none">
                <small className={classNames({"d-flex align-items-center": this.props.links.length === 1}, {"d-none d-md-flex align-items-center": this.props.links.length > 1})}>
                    <span id="related-links-label" className="text-muted me-2 d-none d-md-inline-block">Related:</span>
                    <ul className="d-flex list-inline list-inline-pipe-separated mb-0" aria-labelledby="related-links-label">
                        {listLinks}
                    </ul>
                </small>
                {mobileDropdown}
            </div>
        );
    }
}

RelatedLinks.propTypes = {
    links: PropTypes.array.isRequired
};

export default RelatedLinks; 
